// STT diagnostics — gated on localStorage so they are silent in production.
//
// Enable in any browser/device console with:
//   localStorage.setItem('stt_debug', '1'); location.reload();
// Disable with:
//   localStorage.removeItem('stt_debug'); location.reload();
//
// Central logger so every STT/mic/audio event shares one clock and prefix,
// making it possible to see across-round ordering and timing at a glance.

const start =
  typeof performance !== 'undefined'
    ? performance.now()
    : /* istanbul ignore next */ Date.now();

function now(): number {
  return typeof performance !== 'undefined'
    ? performance.now()
    : /* istanbul ignore next */ Date.now();
}

function isEnabled(): boolean {
  try {
    return !!localStorage.getItem('stt_debug');
  } catch {
    return false;
  }
}

/** Log with a millisecond timestamp relative to module load (gated on stt_debug). */
export function diag(...args: unknown[]): void {
  if (!isEnabled()) return;
  const t = Math.round(now() - start);
  console.log(`[STT-DIAG +${t}ms]`, ...args);
}

/** Snapshot of the page's audio/mic capabilities + any active media. */
export function diagMediaState(label: string): void {
  try {
    const w = window as unknown as {
      AudioContext?: unknown;
      webkitAudioContext?: unknown;
    };
    const audios = Array.from(document.querySelectorAll('audio')).map((a) => ({
      paused: a.paused,
      ended: a.ended,
      currentTime: Number(a.currentTime.toFixed(2)),
      duration: Number.isFinite(a.duration)
        ? /* istanbul ignore next -- finite duration requires loading actual audio; unavailable in jsdom */
          Number(a.duration.toFixed(2))
        : a.duration,
      readyState: a.readyState,
      srcKind: a.currentSrc.slice(0, 16),
    }));
    diag(label, 'audioEls=', audios.length, audios, {
      hasAudioContext: !!(w.AudioContext || w.webkitAudioContext),
    });
  } catch (err) {
    diag(label, 'diagMediaState error', err);
  }
}
